import { defineStore } from 'pinia';
import * as constants from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const useAppStore = defineStore('app', {
    id: 'app',

    state: () => ({
        currentStep: constants.STEP_LOADING,

        isMobile: false,

        isFullscreen: false,

        // We separate working flags so we could control the loading indicator lifetime better.
        // isWorking -> Some long data operation is happening. Saving a recipe for example.
        isWorking: false,

        // isLoading -> Loading data for visualization.
        isLoading: true,

        linkCopied: false,

        selfDestruct: false,

        translations: null,
    }),

    getters: {
        isBusy() {
            return this.isWorking || this.isLoading;
        },
    },

    actions: {
        /**
         * Log an event.
         */
        log({
            level,
            message,
            style,
        }) {
            if (style) {
                // eslint-disable-next-line
                console.log(`%c${level}: ${message}`, style);
            } else {
                // eslint-disable-next-line
                console.log(`${level}: ${message}`);
            }
        },

        /**
         * Sets current application step.
         */
        setCurrentStep(step) {
            this.currentStep = step;
        },

        /**
         * Sets whether the app is in mobile mode.
         */
        setIsMobile(isMobile) {
            this.isMobile = isMobile;
        },

        /**
         * Sets whether the product renderer is in fullscreen mode.
         */
        setIsFullscreen(isFullscreen) {
            this.isFullscreen = isFullscreen;
        },

        /**
         * Sets whether customizer is doing something that takes a long time.
         */
        setIsBusy(isBusy) {
            this.isWorking = isBusy;
        },

        /**
         * Sets secondary busy flag.
         */
        setIsLoading(isBusy) {
            this.isLoading = isBusy;
        },

        /**
         * Sets whether the link to the design was copied to the clipboard.
         */
        setLinkCopied(linkCopied) {
            this.linkCopied = linkCopied;
        },

        /**
         * Close the widget.
         */
        globalDone() {
            this.selfDestruct = true;
        },

        /**
         * Resets the app.
         */
        resetCustomization() {
            this.setCurrentStep(constants.STEP_RESET);

            setTimeout(() => {
                this.setCurrentStep(constants.STEP_LOADING);
            }, '500');
        },

        /**
         * Save translations.
         */
        setTranslations(translations) {
            this.translations = translations;
        },
    },
});
